import { Outlet } from "react-router-dom"
import { ScanNavbar } from "@/components/ScanNavbar"

export function ScanLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <ScanNavbar />

      <main className="flex-1 p-4">
        <Outlet />
      </main>
    </div>
  )
}